import { useNavigate } from 'react-router-dom';
import './FocusAreas.css';

const FOCUS_AREAS = [
  {
    id: 'diet_goals',
    category: 'Diet & Nutrition',
    goals: [
      'Reduce highly processed foods, added sugar, and refined carbs',
      'Cook more meals at home using whole, fresh ingredients',
      'Eat fruits and/or vegetables at most meals',
      'Plan grocery lists and meals ahead of time to make healthier choices',
      'Drink water consistently throughout the day',
    ],
  },
  {
    id: 'mind_wellness_goals',
    category: 'Mind & Mental Wellness',
    goals: [
      'Prioritize consistent, restful sleep',
      'Spend less time on screens and more time outdoors',
      'Be more intentional about spending time with friends, family and community',
      'Keep mind engaged on a daily basis with work, school or other activities',
      'Incorporate moments of calm or reflection into your day',
    ],
  },
  {
    id: 'move_exercise_goals',
    category: 'Exercise & Movement',
    goals: [
      'Stay active throughout the day and minimize prolonged sitting',
      'Find a cardio activity you enjoy and do it regularly',
      'Target muscles through strength training and/or mobility exercises',
      'Combine exercise with social activities',
      'Dedicate time to rest and recovery',
    ],
  },
];

function FocusAreas() {
  const navigate = useNavigate();

  return (
    <div className="focus-areas-page">
      <div className="focus-areas-container">

        <div className="focus-areas-header">
          <img src="/mosaic-icon.png" alt="Mosaime" className="focus-areas-logo" />
          <h1>Your Wellness Focus Areas</h1>
          <p>
            Mosaime works across three areas of your wellbeing. Here's what we'll be tracking
            and nudging you on — and where we'll look to make the biggest difference.
          </p>
        </div>

        {FOCUS_AREAS.map(area => (
          <div key={area.id} className="focus-area-card">
            <h2 className="focus-area-title">{area.category}</h2>
            <ul className="focus-area-goals">
              {area.goals.map(goal => (
                <li key={goal} className="focus-area-goal-row">{goal}</li>
              ))}
            </ul>
          </div>
        ))}

        <div className="focus-areas-actions">
          <button
            className="btn btn-primary focus-areas-continue-btn"
            onClick={() => navigate('/welcome')}
          >
            Continue
          </button>
        </div>

      </div>
    </div>
  );
}

export default FocusAreas;
